<template>
	<div class="keyWordReportList">
		<data-list
			:data="data"
			:columns="column"
			:tableStyle="{ name: 'mixture' }"
			:page="page"
			:page-size="page.pageSize"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		>
		</data-list>
	</div>
</template>

<script>
import listPageCreate from '@/mixins/listPageCreate';
import keywordRanking from '@/backend/services/keywordRanking/keywordRanking';
import api from '@/backend/apiConfig/apiConfig';

const list = listPageCreate({
	searchConfig: {
		api: api.keywordRanking.serpReportTaskList,
		method: 'POST',
	},
});

export default {
	name: 'keyWordReportList',
	mixins: [list],
	props: [],
	components: {},
	data() {
		return {
			column: [
				{
					label: '生成时间',
					bind: 'modifiedTime',
					align: 'center',
				},
				{
					label: '客户名称',
					bind: 'customerName',
					align: 'center',
				},
				{
					label: '域名',
					bind: 'domain',
					align: 'center',
				},
				{
					label: '邮箱',
					bind: row => {
						let { receiver } = row;
						if (receiver) return JSON.parse(receiver).join('，');
						return '-';
					},
					align: 'center',
				},
				{
					label: '操作人',
					bind: 'createrName',
					align: 'center',
				},
				{
					label: '生成状态',
					type: 'mapping',
					mapType: 'text',
					bind: 'status',
					width: 150,
					parentEvent(val) {
						switch (val) {
							case 0:
								return '未生成';
							case 1:
								return '生成中';
							case 2:
								return '生成成功';
							case 3:
								return '生成失败';
						}
					},
					colors(row) {
						switch (row.status) {
							case 0:
								return {
									color: '#606266',
								};
							case 1:
								return {
									color: '#FCC262',
								};
							case 2:
								return {
									color: '#67C23A',
								};
							case 3:
								return {
									color: '#FF3000',
								};
						}
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					style: 'text',
					width: 150,
					bind: [
						{
							text: '刷新',
							trigger: () => {
								this.query();
							},
							showButton(row) {
								return row.status === 1;
							},
						},
						{
							text: '重新生成',
							trigger: row => {
								let { id } = row;
								this.serpReportTaskListAgain(id);
							},
							showButton(row) {
								return row.status === 3;
							},
						},
					],
				},
			],
		};
	},
	mounted() {
		this.query();
	},
	methods: {
		// serp报表任务列表重新生成
		async serpReportTaskListAgain(id) {
			await keywordRanking.serpReportTaskListAgain({ id });
			this.query();
		},
	},
};
</script>

<style lang="scss" scoped>
.keyWordReportList {
}
</style>
